var React = require('react');

function WhitePlusInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"WhitePlus"),React.createElement("path",{"d":"M120.48,474c111.24-5.75,228.89-48.3,337.7-68.95,47-9.1,92.6-24.62,139.56-33.73,40.55-7.77,81.71-3,118.63-15.32,32.56-10.79,10.86-57.14-21.46-48.41-41.27,13.95-92.72,7.92-135.57,17.51-49.26,10.92-96.71,24.15-145.73,33-100.1,17.49-200.8,57.86-301.52,62.75-33.65,2.32-25.27,55.46,8.39,53.14Z","transform":"translate(-90.66 -80.84)","style":{"fill":"currentColor"},"key":1}),React.createElement("path",{"d":"M378.19,102.73c-22.41,191.4,35.45,392.2,61.34,580.91,4.38,33.89,55.46,25.27,51.08-8.62-24.55-182.3-84.71-381.28-61-566.27,3.85-32.93-47.6-38.95-51.46-6Z","transform":"translate(-90.66 -80.84)","style":{"fill":"currentColor"},"key":2})]);
}

WhitePlusInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 641.83 624.32"};

module.exports = WhitePlusInline;

WhitePlusInline.default = WhitePlusInline;
